import Forbidden from 'govbr.frontend.policy/components/Errors/Forbidden/Forbidden';

export default Forbidden;
